import InMemoryStorage from "./in-memory-storage";

interface IStorage {
    get<T>(key: string): T | null;
    set(key: string, value: unknown): void;
    remove(key: string): void;
}

export const canUseLocalStorage = (): boolean => {
    try {
        if (!window || !window.localStorage) {
            return false;
        }

        const testKey = "@wikifolio/storage/test";
        const testVal = "1";

        window.localStorage.setItem(testKey, testVal);

        const storageAvailable = window.localStorage.getItem(testKey) === testVal;

        window.localStorage.removeItem(testKey);

        return storageAvailable;
    } catch {
        return false;
    }
};

class LocalStorage implements IStorage {
    storage: Storage;

    constructor(storage: Storage) {
        this.storage = storage;
    }

    get<T>(key: string): T | null {
        try {
            return JSON.parse(this.storage.getItem(key) || "null") as T | null;
        } catch {
            return null;
        }
    }

    set(key: string, value: unknown): void {
        try {
            this.storage.setItem(key, JSON.stringify(value));
        } catch {
            // ignore write failures (e.g. storage full or unavailable)
        }
    }

    remove(key: string): void {
        try {
            this.storage.removeItem(key);
        } catch {
            // ignore removal failures (e.g. storage unavailable)
        }
    }
}

export const localStorage = new LocalStorage(canUseLocalStorage() ? window.localStorage : new InMemoryStorage());
